import { StoreClockOutlineIcon } from './StoreClockOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 78BFCE81-D4A5-48E9-812D-82417EE9CDC9
 * name store-clock-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-clock-outline.svg
 * tags
 * - Places 
 * - Shopping 
 * - Date / Time 
 */
export const ShopClockOutlineIcon = StoreClockOutlineIcon;
export default ShopClockOutlineIcon